import React from 'react';
export function StarIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__94a90__clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0a1 1 0 01.936.649L15.693 8H23a1 1 0 01.707 1.707l-5.545 5.545 2.774 7.397a1 1 0 01-1.426 1.223L12 19.647l-7.51 4.225a1 1 0 01-1.426-1.223l2.774-7.397L.293 9.707A1 1 0 011 8h7.307L11.064.649A1 1 0 0112 0zm0 3.848L9.936 9.351A1 1 0 019 10H3.414l4.293 4.293a1 1 0 01.23 1.058l-2.038 5.434 5.61-3.157a1 1 0 01.981 0l5.611 3.157-2.037-5.434a1 1 0 01.229-1.058L20.586 10H15a1 1 0 01-.936-.649L12 3.848z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__94a90__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}